import { auth, database, initializeApp } from "firebase/";

const config = {
    apiKey: "AIzaSyDdL8C1MzjsOPhhtng9Nky5PEyiS9eXEuY",
    authDomain: "milanuncios-pro.firebaseapp.com",
    databaseURL: "https://milanuncios-pro.firebaseio.com",
    projectId: "milanuncios-pro",
    storageBucket: "milanuncios-pro.appspot.com",
    messagingSenderId: "733209887442",
    appId: "1:733209887442:web:275e66165dbbfcb4bfa30b",
    measurementId: "G-644R1W9ZDT" 
};

initializeApp(config);

export const ref = database().ref();
export const firebaseAuth = auth;

export const loginAuth = (email, password) => {
  return firebaseAuth().signInWithEmailAndPassword(email, password);
};
